import { format } from 'date-fns'
import { it, enUS, fr, es, de, pt, zhCN, ja, ko, ru, ar, tr, pl, nl, sv, uk, vi, th, id, hi } from 'date-fns/locale'

const localeMap: Record<string, any> = {
  it, en: enUS, fr, es, de, pt, zh: zhCN, ja, ko, ru, ar, tr, pl, nl, sv, uk, vi, th, id, hi,
  ms: enUS, bn: enUS, ur: enUS, fa: enUS,
}

export function formatDate(date: Date, lang: string): string {
  const shortLang = lang.split("-")[0]
  const locale = localeMap[lang] || localeMap[shortLang] || enUS
  return format(date, 'EEE d MMM', { locale })
}

export function formatMinutes(minutes: number): string {
  if (minutes === 0) return ''
  const h = Math.floor(minutes / 60)
  const m = minutes % 60
  if (h === 0) return m + 'min'
  if (m === 0) return h + 'h'
  return h + 'h ' + m + 'min'
}

export function generateId(): string {
  return Math.random().toString(36).substring(2, 9)
}

export function isToday(date: Date): boolean {
  const today = new Date()
  return (
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
  )
}
